var render = function render(){var _vm=this,_c=_vm._self._c;return _c('file-input',_vm._b({ref:"fileUpload",on:{"change":_vm.fileChange}},'file-input',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }